import { render, staticRenderFns } from "./PlanPurchaseCard.vue?vue&type=template&id=60ce0f2f&scoped=true"
import script from "./PlanPurchaseCard.vue?vue&type=script&lang=js"
export * from "./PlanPurchaseCard.vue?vue&type=script&lang=js"
import style0 from "./PlanPurchaseCard.vue?vue&type=style&index=0&id=60ce0f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce0f2f",
  null
  
)

export default component.exports